// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"0d83ccde","521":"8f7d6f7a"}[chunkId] + ".js";
};